<template>
  <div class="cart page-wrapper" v-loading="loading">
    <div class="table-header">
      <h1 class="table-title mobile-hide">
        Selects
      </h1>
      <div v-if="request.products.length" class="table-title cart-header-mobile">
        <div>
          Send {{request.products.length}} {{itemLabel}} to: <br/>
          {{ this.$store.state.user.first_name + ' ' + this.$store.state.user.last_name }}
        </div>
        <div>
          <template v-if="!requested">
            <a @click.prevent="submitRequest" class="button">request</a>
          </template>
          <template v-if="requested">
            <a @click.prevent="submitRequest" class="button">confirmed request</a>
          </template>
          <a @click.prevent="share" class="button white share">email</a>
        </div>
      </div>
      <template v-if="requested">
        <div class="cart-side-confirmed mobile-show">
          Check request history <br/>
          and status <router-link to="/history" class="underlined">here</router-link>.
        </div>
      </template>
    </div>

    <div class="cart-inner full-width">
      <div class="row">
        <div class="col-lg-8 col-sm-12 cart-inner-group cart-list-wrapper">
          <div class="cart-list">
            <div v-if="request.products.length" class="row">
              <div class="col-lg-4 col-md-6 col-sm-12 cart-list-item-wrapper" v-for="product in request.products" v-bind:key="product.id">
                <div class="cart-list-item">

                  <div class="cart-list-item-image">
                    <img @click.prevent="productClickAction(product)" :src="getbase64EncodedImage(product.preview)" />
                  </div>

                  <div class="cart-list-item-description">
                      <a v-if="!requested" @click.prevent="removeItem(product)" class="cart-list-item-remove">remove</a>
                      <a @click.prevent="addToFavorites(product)" class="cart-list-item-remove">save for later</a>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="cart-empty">
              You have no items selected. <br/> Please select items to make a request.
            </div>
          </div>
        </div>
        <div class="col-lg-4 cart-inner-group cart-side-wrapper mobile-hide" v-if="request.products.length">
            <div class="cart-side-group">
              <p class="label">Name:</p>
              <p>{{ this.$store.state.user.first_name + ' ' + this.$store.state.user.last_name }}</p>
            </div>
            <div class="cart-side-action">
              <template v-if="!requested">
                <a @click.prevent="submitRequest" href="#" class="button">request</a>
              </template>
              <template v-if="requested">
                <a @click.prevent="submitRequest" href="#" class="button">confirmed request</a>
              </template>
              <a @click.prevent="download" href="#" class="button white">download</a>
              <a @click.prevent="share" href="#" class="button white">email</a>
            </div>
            <template v-if="requested">
              <div class="cart-side-confirmed">
                Check request history <br/>
                and status <router-link to="/history" class="underlined">here</router-link>.
              </div>
            </template>

          </div>
      </div>
    </div>
  </div>
</template>

<script>
import { HTTP } from '@/services/api'
import { EventBus } from '@/services/eventbus'

export default {
  name: 'Selects',
  metaInfo () {
    return {
      title: 'Selects'
    }
  },
  data () {
    return {
      addresses: [],
      activeAddressId: null,
      activeAddressItem: null,
      loading: false,
      detailsOpened: true,
      request: {
        products: [],
        order_address_id: ''
      },
      requested: false,
      requestedId: null
    }
  },
  computed: {
    itemLabel () {
      return this.request.products.length > 1 ? 'items' : 'item'
    }
  },
  watch: {
    '$store.state.request': {
      handler () {
        if (!this.requested) {
          this.loadProducts()
        }
      },
      deep: false
    }
  },
  created () {
    this.loadAddresses()
    this.loadProducts()
  },
  mounted () {
    window.addEventListener('unload', this.emptyCart)
  },
  destroyed () {
    this.emptyCart()
    window.removeEventListener('unload', this.emptyCart)
  },
  methods: {
    loadProducts () {
      this.request.products = this.$store.state.request.slice().reverse()
    },
    getbase64EncodedImage (item) {
      return 'data:image/jpeg;base64,' + item.replace(/(\r\n|\n|\r)/gm, '')
    },
    addToFavorites (product) {
      HTTP({
        method: 'POST',
        url: '/api/v1/favorites',
        crossdomain: true,
        data: {
          ids: [product.id]
        }
      })
        .then(response => {
          if (response.data.data) {
            this.$store.dispatch('setFavorites', response.data.data)
            this.$notify({
              // title: 'Success',
              message: 'Added to saved items',
              type: 'success',
              position: 'bottom-right',
              duration: 1750
            })
          }
          this.removeItem(product)
        })
        .catch((error) => {
          this.$notify({
            // title: 'Error',
            dangerouslyUseHTMLString: true,
            message: error.response.data ? this.parseErrorMessage(error.response.data.error) : 'Error occured. Please try later',
            type: 'error',
            position: 'bottom-right',
            duration: 1750
          })
        })
    },
    removeItem (item, all = false) {
      if (this.requested && this.requestedId && !all) {
        return
      }

      this.$store.dispatch('removeRequestItem', {
        item: item,
        all: all
      })
    },
    emptyCart () {
      if (this.requested) {
        this.removeItem({}, true)
      }
    },
    download () {
      this.loading = true
      HTTP({
        headers: {
          'content-type': 'application/x-www-form-urlencoded'
        },
        method: 'GET',
        responseType: 'arraybuffer',
        url: '/api/v1/assets/download',
        crossdomain: true,
        params: {
          ids: this.request.products.map(function (item) { return item.id })
        }
      })
        .then(response => {
          let headers = response.headers
          let headerLine = headers['content-disposition']
          let startFileNameIndex = headerLine.indexOf('=') + 1
          let endFileNameIndex = headerLine.length

          let blob = new Blob([response.data], { type: headers['content-type'] })
          let link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          link.download = headerLine.substring(startFileNameIndex, endFileNameIndex)
          link.click()
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
    },
    submitRequest () {
      if (!this.request.products.length) {
        this.$notify({
          message: 'You have no selects. Please add items to make request.',
          type: 'error',
          position: 'bottom-right',
          duration: 1750
        })
        return
      }

      if (this.requested) {
        this.$notify({
          message: 'Already requested',
          type: 'error',
          position: 'bottom-right',
          duration: 1750
        })
        return
      }

      this.requestObject = {
        'products': this.request.products.map(function (item) {
          return {
            'id': item.id,
            'filename': item.filename,
            'path': item.path
          }
        })
      }

      this.loading = true
      HTTP({
        method: 'POST',
        url: '/api/v1/orders',
        crossdomain: true,
        data: this.requestObject
      })
        .then(response => {
          this.loading = false
          if (response.data.data) {
            this.requested = true
            this.requestedId = response.data.data.id
          }
          this.emptyCart()
        })
        .catch((error) => {
          this.loading = false
          this.$notify({
            dangerouslyUseHTMLString: true,
            message: error.response.data ? this.parseErrorMessage(error.response.data.error) : 'Error occured. Please try later',
            type: 'error',
            position: 'bottom-right',
            duration: 1750
          })
        })
    },
    share () {
      EventBus.$emit('open-modal', {
        type: 'public-asset-share',
        header: false,
        data: {
          ids: this.request.products.map(function (item) { return item.id }),
          filenames: this.request.products.map(function (item) { return item.filename })
        }
      })
    },
    loadAddresses () {
      HTTP({
        method: 'GET',
        url: '/api/v1/orders/address/',
        crossdomain: true
      }).then(response => {
        this.addresses = response.data.data
        this.activeAddressId = this.addresses[0].id
        this.selectedAddress(this.addresses[0])
      }).catch(error => {
        this.$notify({
          // title: 'Error',
          dangerouslyUseHTMLString: true,
          message: error.response.data ? this.parseErrorMessage(error.response.data.error) : 'Error occured. Please try later',
          type: 'error',
          position: 'bottom-right',
          duration: 1750
        })
        this.loading = false
      })
    },
    selectedAddress (item) {
      if (!this.requested) {
        this.request.order_address_id = item.id
        this.activeAddressId = item.id
        this.activeAddressItem = item
        this.$forceUpdate()
      }
    },
    productClickAction (product) {
      this.$router.push('/products/' + product.id)
    }
  }
}
</script>
